export const LOGIN_PATH = '/Login'
export const LOGOUT_PATH = '/Logout'
export const CREATE_ACCOUNT_PATH = '/CreateAccount'
export const VERIFY_EMAIL_PATH = '/VerifyEmail'
export const MAIN_PATH = ''

//Clients
export const CLIENT_PATH = `${MAIN_PATH}/Client/:clientId`
export const CLIENT_TICKETS_PATH = `${CLIENT_PATH}/TICKETS/Active`
